import React from 'react';
import { Alert, Card, CardHeader, Skeleton } from '@opendate-app/setlist';
import { compactCurrency } from '../../utils/reportingUtils';
import { metricChange, netMembersChange } from '../../utils/dashboardUtils';

const SUBTITLE = "Revenue that isn't tied to one show";
const count = new Intl.NumberFormat('en-US');
const SIGN = { up: '+', down: '−', flat: '' };
const CHANGE_COLOR = { up: 'var(--sl-text-success)', down: 'var(--sl-text-error)', flat: 'var(--sl-text-tertiary)' };

export function membershipRows(data, links) {
  const { members, packs, donations } = data;
  return [
    {
      key: 'members', label: 'Active members', href: links.members,
      value: count.format(members.active), change: netMembersChange(members.net),
      sub: `${count.format(members.pending_cancelations)} pending cancelations`,
    },
    {
      key: 'packs', label: 'Packs & passes sold', href: links.packs,
      value: count.format(packs.sold), change: metricChange(packs.sold, packs.prior_sold),
      sub: `${count.format(packs.unredeemed_picks)} picks not yet redeemed`,
    },
    {
      key: 'donations', label: 'Donations', href: links.donations,
      value: compactCurrency(donations.net), change: metricChange(donations.net, donations.prior_net),
      sub: `${count.format(donations.lybunt_donors)} LYBUNT donors to re-engage`,
    },
  ];
}

function MembershipRow({ row }) {
  return (
    <div style={{ padding: '10px 0', borderTop: '1px solid var(--sl-border-secondary)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 }}>
        <a href={row.href} style={{ fontSize: 13, color: 'var(--sl-text-secondary)' }}>{row.label}</a>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--sl-text-primary)', whiteSpace: 'nowrap' }}>
          {row.value}
          {row.change && (
            <span style={{ marginLeft: 8, fontSize: 12, fontWeight: 500, color: CHANGE_COLOR[row.change.direction] }}>
              {`${SIGN[row.change.direction]}${row.change.value}`}
            </span>
          )}
        </span>
      </div>
      <div style={{ fontSize: 12, color: 'var(--sl-text-tertiary)', marginTop: 2 }}>{row.sub}</div>
    </div>
  );
}

function MembershipsPacksCard({ data, loading, error, links, showPurchaseCaption, allRooms }) {
  return (
    <Card
      style={{ height: '100%' }}
      header={(
        <CardHeader
          title={<a href={links.members} style={{ color: 'inherit' }}>Memberships &amp; packs →</a>}
          supportingText={[SUBTITLE, showPurchaseCaption && 'By purchase date', allRooms && 'Not filtered by room'].filter(Boolean).join(' · ')}
        />
      )}
    >
      {loading && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {Array.from({ length: 3 }, (_, i) => <Skeleton key={i} width="100%" height={44} />)}
        </div>
      )}
      {!loading && error && <Alert color="error" title="Couldn't load memberships and packs" description="Refresh the page to try again." />}
      {!loading && !error && data && membershipRows(data, links).map((row) => <MembershipRow key={row.key} row={row} />)}
    </Card>
  );
}

export default MembershipsPacksCard;
